export default {
  // 初始化St
  SET_LOGINST: (state, login_info) => {
    state.loginInfo = login_info.data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/login/mutation.js